'use client'

import s from "@/app/[locale]/news/page.module.scss";
import {NewsCard} from "@/app/[locale]/common/components/News/NewsCard";
import {INDEX_COUNT} from "../../common/constants/app";
import {Line} from "@/app/[locale]/common/components/Line/Line";
import {TAllNewsItem, TNewsClientComponentProps} from "@/app/[locale]/news/types";
import {Fragment, useEffect, useState} from "react";
import {getStateFromLocalStorage} from "@/app/[locale]/common/utils/functions/getStateFromLocalStorage/getStateFromLocalStorage";
import {getAllNews} from "@/app/[locale]/common/utils/functions/getAllNews/getAllNews";
import {extractTextNewsFromJSON} from "@/app/[locale]/common/utils/functions/extractTextNewsFromJSON/extractTextNewsFromJSON";
import {Pagination} from "@/app/[locale]/common/components/Pagination/Pagination";
import {Preloader} from "@/app/[locale]/common/components/Preloader/Preloader";
import {Empty} from "@/app/[locale]/common/components/Empty/Empty";

export const NewsClientComponent = ({ currentPage }: TNewsClientComponentProps) => {
    const [ data, setData ] = useState<TAllNewsItem[] | null>(null);
    const [ rowTotalCount, setRowTotalCount ] = useState<number>(1);
    const [ currentPageNumber, setCurrentPageNumber ] = useState<null | number>(null);

    useEffect(() => {
        const fetchData = async () => {
            if (currentPage === 1) {
                const storedNews = getStateFromLocalStorage('news');
                const storedRowTotalCount = getStateFromLocalStorage('rowTotalCount');

                if (!storedNews || !storedRowTotalCount) {
                    await getAllNews(currentPage, setData, setRowTotalCount);
                    setCurrentPageNumber(currentPage);
                    return;
                }

                if (storedRowTotalCount) {
                    setRowTotalCount(storedRowTotalCount);
                }

                if (storedNews) {
                    const news = extractTextNewsFromJSON(storedNews);
                    setData(news);
                    setCurrentPageNumber(currentPage);
                    return;
                }
            }
            await getAllNews(currentPage, setData, setRowTotalCount);
            setCurrentPageNumber(currentPage);
        }

        fetchData();
    },[currentPage]);

    if (!data || currentPageNumber !== currentPage) {
        return <Preloader />;
    }

    if (!data.length) {
        return <Empty />;
    }

    return (
        <div className={s.news_newsWrapper}>
            <div className={s.news_all}>
                {
                    data.map((item: TAllNewsItem, index: number) => (
                        <Fragment key={item.id}>
                            <div className={s.news_card}>
                                <NewsCard
                                    title={item.title}
                                    id={item.id}
                                    text={item.text}
                                    date={item.date}
                                    image={item.img}
                                />
                            </div>
                            {
                                data.length - INDEX_COUNT.ONE !== index &&
                                <Line className={s.news_cardLine}/>
                            }
                        </Fragment>
                    ))
                }
            </div>
            <div className={s.news_pagination}>
                <Pagination
                    type={'news'}
                    currentPage={currentPage}
                    numberPages={Math.ceil(rowTotalCount / 4)}
                />
            </div>
        </div>
    );
};
